import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "btn-group" }
const _hoisted_2 = {
  type: "button",
  class: "btn",
  disabled: ""
}
const _hoisted_3 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn dropdown-toggle dropdown-toggle-split",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Toggle Dropdown")
], -1)
const _hoisted_4 = { class: "dropdown-menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("button", _hoisted_2, _toDisplayString(_ctx.parity.local) + ":" + _toDisplayString(_ctx.parity.cripto), 1),
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.parities, (prt) => {
        return (_openBlock(), _createBlock("div", {
          key: prt.id
        }, [
          _createVNode("button", {
            class: "dropdown-item",
            onClick: ($event: any) => (_ctx.changeParity(prt))
          }, _toDisplayString(prt.local) + ":" + _toDisplayString(prt.cripto), 9, ["onClick"])
        ]))
      }), 128))
    ])
  ]))
}